import { lazy } from 'react';

const DonationsPage = lazy(() => import('./pages/DonationsPage'));

export const DonationsEntry = () => <DonationsPage />;
